module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1099.81c8f7e7.png";